import React, { FC, useCallback } from 'react';
import { useGridApiContext } from '@mui/x-data-grid-premium';
import Pill from '@ingka/pill';
import filterIcon from '@ingka/ssr-icon/paths/filters';

type FiltersButtonProps = {
  setFilterAnchorEl: (el: HTMLElement | null) => void;
};

const returnAppliedFilters = (apiRef: any): number => {
  return apiRef.current.state.filter.filterModel.items.length;
};

const FiltersButton: FC<FiltersButtonProps> = ({ setFilterAnchorEl }) => {
  const apiRef = useGridApiContext();

  const toggleFilter = useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      setFilterAnchorEl(event.currentTarget);
      apiRef.current.showFilterPanel();
    },
    [apiRef, setFilterAnchorEl],
  );

  return (
    <div>
      <Pill
        label={`Filter ${
          returnAppliedFilters(apiRef) > 0
            ? `(${returnAppliedFilters(apiRef)})`
            : ''
        }`}
        onClick={toggleFilter}
        size="small"
        trailingIcon={filterIcon}
      />
    </div>
  );
};

export default FiltersButton;
